export const ToolbarWrapper = ({children} ) => {
    return (
        <div style={{lineHeight: 1, fontSize: "25px", width: "25px", height: "100%", display : "flex" , justifyContent: "center", alignItems: "center"}}>
            {children}
        </div>
    )
}
